import { render } from "./KeyQuestionContainer.vue?vue&type=template&id=045f568a&scoped=true"
import script from "./KeyQuestionContainer.vue?vue&type=script&lang=js"
export * from "./KeyQuestionContainer.vue?vue&type=script&lang=js"

import "./KeyQuestionContainer.vue?vue&type=style&index=0&id=045f568a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045f568a"]])

export default __exports__